import React, { useState, useEffect, useRef } from 'react'
import Loading from '../Loading';
import { messageCustom, RepeatRemove, PopulateConversation , getDataNameAndHour, 
    convertToBase64, phone_format, RepeatRemoveHeader,getUnread, prioritizeData} from "./../../components/Utils";
import ShowMessages from './../Exceptions'
import { setCookieMessage } from './../Cookies';
import Swal from 'sweetalert2'
import {setDataDB, getDataDB, lastID, setID } from '../../services/idb'
import { USER_DATA, ReadDataStorage, IDCOMPANY, IDUSER} from './../../services/auth'
import { useChatData } from './chatContext'
import USER from './../../assets/user-gray.png'
import api from '../../services/api'
import {subHours,isEqual  } from 'date-fns'
import {Dropdown} from 'react-bootstrap'
import ModalSelectedNumber from './../../pages/modals/modal-selected-number'

import WHATSAPP from './../../assets/whatsapp.png'

export default function MessageList({ props }) {
    const [showModal, setShowModal]                     = useState(false)
    const [loading, setLoading]                         = useState(false)
    const [loadingInfinite, setLoadingInfinite]         = useState(false)
    const [isRecording, setIsRecording]                 = useState(false)
    const [newChat, setNewChat]                         = useState(false)  
    const [leads, setLeads]                             = useState([])
    const [leadsAll, setLeadsAll]                       = useState([])
    const [textSearch, setTextSearch]                   = useState('')
    const [dataTag, setDataTag]                         = useState([])
    const [page, setPage]                               = useState(1)
    const [lastPage, setLastPage]                       = useState(1)
    const [numberSettings, setNumberSettings]           = useState([])
    const [filterTag, setFilterTag]                     = useState(0)
    
    const [infiniteScroll, setInfiniteScroll]          = useState(false)

    const [showContextMenu, setShowContextMenu]         = useState(false)
    const [position, setPosition]                       = useState({})
    const [propsShowChat, setPropsShowChat]             = useState({})
    const containerRef                                  = useRef(null)
    const searchTextRef                                 = useRef('')
    const filterDebounceRef                             = useRef(null)
    const searchInputRef                                = useRef(null)
    const leadsAllRef                                   = useRef([])
    const headerListCacheRef                            = useRef(null)
    const headerListCacheKeyRef                         = useRef('')
    const FILTER_DEBOUNCE_MS                            = 450

    useEffect(() => {
        leadsAllRef.current = leadsAll
    }, [leadsAll])

    const {  setStartHuman, setNumber,setIdAttendant,setIsNotRead, setParticipants,
        setEndHuman, setIsOpened, settings, setTo,setUserNumber,to,userNumber,
    chatList, setChatList, setConversation, setNameUser, setIsUnanswered,
    setPhotoUser, setIDPeople, setLoadingChat,isNotRead, isUnanswered,
    setIdAutomationChatHeadHistory, setUnread, handleReload,setFilename,
    setIsGroup, setShowPreview, showPreview, setSelectedFiles, setMessageType} = useChatData()

    const settingsRef = useRef(settings)
    useEffect(() => {
        settingsRef.current = settings
    }, [settings])

    const _div = containerRef.current
    const loadingChatList = async (action, id, newPage) => {
        // 1 - isNotRead
        // 2 - isUnanswered
        // 3 - onlytag
        let _url
        setLoadingInfinite(true)
        setInfiniteScroll(true)
        if (newPage === 0)
            setLoading(true)
        switch (action) {
            case 0 : _url = `/getChatList/${page}`
                setIsNotRead(false)
                setIsUnanswered(false)
                setFilterTag(0)
                break;
            case 1 : _url = isNotRead ? `/getChatList/${page}` : `/getChatListNotRead/${page}`
                     setIsNotRead(!isNotRead)
                break;
            case 2 : _url = isUnanswered ? `/getChatList/${page}` : `/getChatListUnanswered/${page}`
                     setIsUnanswered(!isUnanswered)
                break;
            case 3 : _url = id > 0 ? `/getChatTag/${page}/` + id : `/getChatList/${page}`
                setFilterTag(id)
                break
            default:
                break;
        }

 
        await api.get(_url)
                 .then(async (response) => { 
                    let _unread = response.data?.data?.reduce((_total,_item) => {
                        return _total + getUnread(_item.unread,ReadDataStorage(IDUSER))
                    },0)

                    setLastPage(response.data?.lastPage)
                    //GRAVA MENSAGENS NO IDB E SETA NA USESTATE
                    if (response.data?.data?.length > 0) {
                        // if (page > 1) {
                        //     let _header = [...(await getDataDB('HEADER-' + ReadDataStorage(IDUSER),ReadDataStorage(IDCOMPANY)) || []),...response.data.data]
                        //     _header.sort((a, b) => new Date(b.update_at) - new Date(a.update_at));
                        //    // if ([6].includes(settings.modeType))
                        //      setDataDB('HEADER-'+ReadDataStorage(IDUSER),_header,handleReload,ReadDataStorage(IDCOMPANY))
                        // } else {
                        //     //if ([6].includes(settings.modeType))
                        //     console.log('HEADER',ReadDataStorage(IDCOMPANY))
                        //     setDataDB('HEADER-'+ReadDataStorage(IDUSER),response.data.data,handleReload,ReadDataStorage(IDCOMPANY))
                        // }

                        let _header = [...(await getDataDB('HEADER-' + ReadDataStorage(IDUSER),ReadDataStorage(IDCOMPANY)) || []),...response.data.data]
                        _header.sort((a, b) => {
                            if (a.pinned !== b.pinned) 
                                return b.pinned - a.pinned;
                            return new Date(b.update_at) - new Date(a.update_at);
                        })
                        _header = RepeatRemoveHeader(_header)
                        headerListCacheRef.current = _header
                        headerListCacheKeyRef.current = `${ReadDataStorage(IDUSER)}|${ReadDataStorage(IDCOMPANY)}`
                        setDataDB('HEADER-'+ReadDataStorage(IDUSER),_header,handleReload,ReadDataStorage(IDCOMPANY))
                        setChatList(_header)
                        setUnread(_unread)
                    }

                    setLoading(false)
                    setLoadingInfinite(false)
                }).catch(error => {
                    setLoading(false)
                    ShowMessages(error)
                }) 
    }
    
    const showChat = async(notifyName,photo,_to,_startHuman,_endHuman,idautomationchatheadhistory,idpeople,idAttendant,number,_numberSettings,isGroup, _participants) => {

        let _number    = number
        let _chatList  = [] 
        setLoadingChat(true)

        setIdAutomationChatHeadHistory(idautomationchatheadhistory)

        const _getConversation = async(lastID,number) => {
            await api.post('/getConversation/1', {lastID, 
                                                  number : (number || '').toString().replace(/[\W_,[a-z]+/g,""),
                                                  to : _to.toString().replace(/[\W_,[a-z]+/g,""),
                                                  isNotRead,
                                                  isUnanswered,
                                                  filterTag,
                                                  idautomationchatheadhistory
                       }).then(async(response) => { 
                            let rConversation = response.data?.conversation || []
                            let _msg  = []

                            rConversation.map(_item => {
                                let _populate = PopulateConversation(_item,_item.isreceive)
                                _msg.push(_populate)
                            })
            
                            let _conversationDB = [..._msg || [],...(await getDataDB(_keyNumber + '-' + ReadDataStorage(IDUSER),ReadDataStorage(IDCOMPANY)) || [])] 
                  
                            _conversationDB = RepeatRemove(_conversationDB)
              
                            if ((settings.modeType === 6) &&  (!JSON.parse(ReadDataStorage(USER_DATA)).user_data.isroot))
                                _conversationDB = _conversationDB.filter(_item => _item.idautomationchatheadhistory === idautomationchatheadhistory)

                            response.data?.dataUpdate?.map(_item => {
                                let _conversation = _conversationDB.find(_filter => {
                                    return _filter.idmessage === _item.idmessage
                                })
                                if (_conversation)
                                    _conversation.ack = _item.ack
                            })         

                            _conversationDB.sort((a, b) => {
                                if (isEqual(new Date(a.create_at) , new Date(b.create_at))) 
                                    return new Date(a.idmessagehistory) - new Date(b.idmessagehistory);
                                else
                                    return new Date(a.create_at) - new Date(b.create_at);
                            })
                           
                            setConversation(_conversationDB)
                            setDataDB(_keyNumber + '-' + ReadDataStorage(IDUSER),_conversationDB,null,ReadDataStorage(IDCOMPANY))
                            let _count = response.data?.data?.conversation.length

                            //SETA O ULTIMO ID DE MENSAGEM O IDB
                            if (_count > 0)
                                setID(_keyNumber,response.data?.conversation[_count-1].idmessagehistory,ReadDataStorage(IDCOMPANY))
         
                            _chatList = [...(await getDataDB('HEADER-' + ReadDataStorage(IDUSER),ReadDataStorage(IDCOMPANY)) || []),...response.data?.chatList?.data || []]
                            const _selectUnread = prioritizeData(response.data?.chatList?.data || [],await getDataDB('HEADER-' + ReadDataStorage(IDUSER),ReadDataStorage(IDCOMPANY)))
                            let _unread = _selectUnread.reduce((_total,_item) => {
                                return _total +  getUnread(_item.unread,ReadDataStorage(IDUSER))
                            },0) 
              
 
                            setUnread(_unread)
                            _chatList = RepeatRemoveHeader(_chatList)
                            setChatList(_chatList)
                            handleFilter()
                            //setIdAutomationChatHeadHistory(response.data?.chatList.data[0].idautomationchatheadhistory)
                            
                            setNameUser(notifyName || response.data?.header?.notifyname)
                            setPhotoUser(photo || response.data?.header?.photo)
                            if (idpeople === 0)
                                setIDPeople(response.data?.header?.idpeople)
                            setCookieMessage('idchat',parseInt(response.data?.header?.idmessagehistoryheader))
                            setNumber(response.data?.header?.number || number)
                            _number = response.data?.header?.number || number
                            setTo(response.data?.header?.to || _to)
                          
                       }).catch(error => {
                            ShowMessages(error)
                       }) 
        }

        const getNumber = async() => {
            let _numbers = (_numberSettings || numberSettings).filter(_item => _item.idnumberstatus === 1)

            if (_numbers.length <= 0) {
                ShowMessages({ status: 500, message: 'Nenhum número está conectado no momento.' })
                return ''
            } else if (_numbers.length === 1) {
                return _numbers[0].number
            } else {
                const _header = await api.post('/getChatFromTo',{to : _to})
                                         .then((response) => {
                                            return response.data
                                         }).catch((error) => {
                                            ShowMessages(error)
                                         })           
                                         
                if  (_header) {                       
                    let _numberFound = _numbers.filter(_item => _item.number === _header.number)
   
                    if (_numberFound.length === 1)
                        return _numberFound[0].number
                    else {
                        setPropsShowChat({
                            notifyName, photo, to, _startHuman, _endHuman, idautomationchatheadhistory, idpeople, idAttendant, _numbers, _numberSettings, isGroup,participants : null
                        })
                        setShowModal(true)
                        return null
                    }
                } else {
                    setPropsShowChat({
                        notifyName, photo, to, _startHuman, _endHuman, idautomationchatheadhistory, idpeople, idAttendant, _numbers, _numberSettings, isGroup,participants : null
                    })
                    setShowModal(true)
                    return null
                }
            }
        }
   
        let _checkNewChat = chatList.filter(_item => {
            //return ((_item.to.toString() === (_to.length <= 11 ? '55' : '') + _to.toString()) && (_item.original_number.toString() === _number.toString()))
            //RETIRADO PORQUE QUANDO E UM NUMERO INTERNACIONAL NÃO ABRE O CHAT
            const sameTo = _item.to.toString() === _to.toString()
            const sameNumber =
                _number != null &&
                String(_number).trim() !== '' &&
                _item.original_number.toString() === _number.toString()
            return sameTo && sameNumber
        })
 
        let _keyNumber = number + '_' + _to.toString().replace(/[\W_,[a-z]+/g,"")
        let _lastID    = (await lastID(_keyNumber,ReadDataStorage(IDCOMPANY))) || 0
        
        setNameUser(notifyName)
        setPhotoUser(photo)
        setIDPeople(idpeople)
        setTo(_to)

  
        let _selectNumber = number ? number : (await getNumber())
        if (!_selectNumber)//ATIVA A TELA PARA ESCOLHER O NUMERO E AVANÇA O ATENDIMENTO
            return
    
        if ([6].includes(settings.modeType) && (_endHuman))  {
            _chatList = await getDataDB('HEADER-' + ReadDataStorage(IDUSER),ReadDataStorage(IDCOMPANY)) || []
            setConversation([])
        } else {
            if (_number) {
                await _getConversation(_lastID, _number)
            } else if ((_checkNewChat.length === 0) && (!_number)) {
                await _getConversation(_lastID, null)
    
                if (!_number) {
                    if (_selectNumber && _selectNumber !== '') {
                        _keyNumber = _selectNumber + '_' + _to.toString().replace(/[\W_,[a-z]+/g, "")
                        _lastID = (await lastID(_keyNumber, ReadDataStorage(IDCOMPANY))) || 0
                        await _getConversation(_lastID, _selectNumber)
                    }
                }
            }
        }


        if (_checkNewChat.length <= 0) {
            const toForApi = _to != null && _to !== undefined ? String(_to).trim() : ''
            const numForApi =
                _number != null && String(_number).trim() !== ''
                    ? String(_number).trim()
                    : String(_selectNumber || '').trim()

            let _header = null
            if (toForApi !== '' && numForApi !== '') {
                _header = await api
                    .post('/getChatFromToAndNumber', { to: toForApi, number: numForApi })
                    .then((response) => response.data)
                    .catch((error) => {
                        ShowMessages(error)
                    })
            }

            let _newChat
            if (_header) {
                _newChat = {body : _header.body,
                            hasmedia : _header.hasmedia,
                            photo : _header.photo,
                            notifyname : phone_format(_header.to),
                            notifyusergroup : _header.notifyusergroup,
                            isgroup : _header.isgroup,
                            idmessagehistoryheader : _header.idmessagehistoryheader,
                            unread : getUnread(_header.unread,ReadDataStorage(IDUSER)),
                            update_at : _header.update_at,
                            tags : _header.tags,
                            to : _header.to,
                            type : _header.type,
                            idautomationchatheadhistory : _header.idautomationchatheadhistory,
                            starthuman : _header.starthuman,
                            endhuman : _header.endhuman,
                            number : phone_format(_header.number),
                            original_number : _header.number,
                            name : _header.name,
                            idattendant : _header.idattendant}
            } else {
                setConversation([])
                _newChat = {body : '',
                            hasmedia : false,
                            photo : '',
                            notifyname : phone_format(to),
                            notifyusergroup : '',
                            isgroup : false,
                            idmessagehistoryheader : 0,
                            unread : 0,
                            update_at : new Date(),
                            tags : [],
                            to : _to,
                            type : 'chat',
                            idautomationchatheadhistory : 0,
                            starthuman : null,
                            endhuman : null,
                            number : phone_format(_selectNumber),
                            original_number : _selectNumber,
                            name : '',
                            idattendant : ReadDataStorage(IDUSER)}
            }


            _chatList.push(_newChat)
            _chatList.sort((a, b) => {
                if (a.pinned !== b.pinned) 
                    return b.pinned - a.pinned;
                return new Date(b.update_at) - new Date(a.update_at);
            })
            _chatList = RepeatRemoveHeader(_chatList)
            setDataDB('HEADER-'+ReadDataStorage(IDUSER),_chatList,null,ReadDataStorage(IDCOMPANY))
            setChatList(_chatList)
        } else {
            if (_checkNewChat[0].isCRMLead) {
                _checkNewChat[0].number = phone_format(_selectNumber)
                _checkNewChat[0].original_number = _selectNumber
                
            }

            setCookieMessage('idchat',parseInt(_checkNewChat[0].idmessagehistoryheader))
        }


        setUserNumber(_selectNumber)
        setNumber( _selectNumber)
        setIsOpened(_startHuman !== null && _endHuman === null)
        setStartHuman(_startHuman)
        setIsGroup(isGroup)
        setEndHuman(_endHuman)
        setShowPreview(false)
        setNewChat(false)
        setIdAttendant(idAttendant)  
        setLoadingChat(false)
        setParticipants(_participants)

    }

    window.showChat = showChat

    const normalizeSearchDigits = (s) => String(s || '').replace(/\D/g, '')

    const buildHeaderMatcher = (text) => {
        const t = String(text || '').trim()
        if (!t) return () => true
        const qLower = t.toLowerCase()
        const qDigits = normalizeSearchDigits(t)
        const needDigits = qDigits.length >= 2
        return (_item) => {
            const name = String(_item.notifyname || '').toLowerCase()
            const toRaw = String(_item.to || '')
            if (name.includes(qLower) || toRaw.toLowerCase().includes(qLower)) return true
            if (needDigits && normalizeSearchDigits(toRaw).includes(qDigits)) return true
            return false
        }
    }

    const applyChatListFilter = async (text) => {
        const t = text === undefined || text === null ? String(searchTextRef.current || '') : String(text)
        const headerKey = 'HEADER-' + ReadDataStorage(IDUSER)
        const company = ReadDataStorage(IDCOMPANY)
        const cacheKey = `${ReadDataStorage(IDUSER)}|${company}`
        let _list
        if (headerListCacheRef.current !== null && headerListCacheKeyRef.current === cacheKey) {
            _list = headerListCacheRef.current
        } else {
            _list = (await getDataDB(headerKey, company)) || []
            headerListCacheRef.current = _list
            headerListCacheKeyRef.current = cacheKey
        }

        const leads = leadsAllRef.current
        if ((leads.length > 1000) && (t.length > 0) && (t.length < 4)) {
            _list = RepeatRemoveHeader(_list)
            setChatList(_list)
            return
        }

        if (t !== '') {
            const match = buildHeaderMatcher(t)
            _list = _list.concat(leads)
            const out = []
            for (let i = 0; i < _list.length; i++) {
                if (match(_list[i])) out.push(_list[i])
            }
            _list = RepeatRemoveHeader(out)
        } else {
            _list = RepeatRemoveHeader(_list)
        }
        setChatList(_list)
    }

    const handleFilter = () => {
        if (filterDebounceRef.current) {
            clearTimeout(filterDebounceRef.current)
            filterDebounceRef.current = null
        }
        headerListCacheRef.current = null
        headerListCacheKeyRef.current = ''
        void applyChatListFilter(searchTextRef.current)
    }

    const onSearchInputChange = (e) => {
        const v = e.target.value
        searchTextRef.current = v
        if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current)
        filterDebounceRef.current = setTimeout(() => {
            filterDebounceRef.current = null
            const q = searchTextRef.current
            setTextSearch(q)
            void applyChatListFilter(q)
        }, FILTER_DEBOUNCE_MS)
    }

    const escExit = (e) => {
        if (e.keyCode === 27) {
            if (showPreview) {
                setShowPreview(false)
            }
        }
    }

    const getNumberSettings = async() => {
        return await api.get('/getPermissionNumbers')
                        .then((response) => {
                            setNumberSettings(response.data)
                            return response.data
                        }).catch((error) => {
                            ShowMessages(error)
                        })           
    }

    const toMap = (text) => {
        if (text) {
            let _tag = typeof text === 'object' ? text : JSON.parse(text)
            let _return = []
            _tag.map(_i => {
                let _filter = dataTag.filter(_item => {
                    return parseInt(_item.idtag) === parseInt(_i.tag)
                })

                if (_filter.length > 0)
                    _return.push({
                        text  : _filter[0].tag,
                        color : _filter[0].color
                    })
            })
            return _return
        } else {
            return []
        }
    }

    const deleteMessage = (id) => {
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente excluir todo o histório de conversa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
          }).then(async(result) => {
            if (result.isConfirmed) {
                await api.delete('/history/' + id) 
                         .then((response) => {  
                            ShowMessages(response)
                            props.setUpdate()
                        }).catch(error => {
                            ShowMessages(error)
                        })  
            }
            
          })
    }

    const pinnedMessage = async(e,id) => {
        
        //ATUALIZAÇÃO FEITA POR FORA DA REQUISIÇÃO PARA GANHAR TEMPO
        let _chatList = chatList.find(_item => {
            return _item.idmessagehistoryheader === id

        })
        _chatList.pinned = !_chatList.pinned
        
        chatList.sort((a, b) => {
            if (a.pinned !== b.pinned) 
                return b.pinned - a.pinned;
            return new Date(b.update_at) - new Date(a.update_at);
        })

       // e.stopPropagation()
        await api.post('/history/pinned/',{
            id
        }).then((response) => {
            //
        }).catch((error) => {
           ShowMessages(error)
        })
    }
    
    const getColor = (number) => {

        if ((number === '') || (number === undefined))
            return '#ffc107'

        let _data = numberSettings.filter(_item => _item.number === number.toString().replace(/[\W_,[a-z]+/g,''))

        if (_data.length > 0)
            return _data[0].numbercolor
        else
            return '#ffc107'
    }

    const CountUp = ({initialDate}) => {
        const [timeLeft, setTimeLeft] = useState(getTimeLeft(initialDate));

        function getTimeLeft(startDate) {
            const now = new Date()

            const difference = now.getTime() - subHours(new Date(startDate),-3).getTime();
      
            const hours = Math.floor(difference / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      
            return {
                hours,
                minutes,
                seconds
            };
        }
      
        useEffect(() => {
            const timer = setInterval(() => {
                setTimeLeft(getTimeLeft(initialDate));
            }, 1000);
      
            return () => clearInterval(timer);
        }, [initialDate]);
      
        return (
            <div className='bg alert alert-primary' style={{padding:"1px 5px", borderRadius:"5px", display:"flex", justifyContent:"center",alignItems:"center", marginBottom:"3px"}}>
                <i className='fa fa-headset' style={{fontSize:"10px"}}/>
                <span style={{fontSize:"10px", marginLeft:"5px"}}>{(timeLeft.hours.toString().length === 1 ? '0' : '') + timeLeft.hours}:{(timeLeft.minutes.toString().length === 1 ? '0' : '') + timeLeft.minutes}:{(timeLeft.seconds.toString().length === 1 ? '0' : '') + timeLeft.seconds}</span>
            </div>
        );
    }
  
    const handleCloseModal = () => { setShowModal(false)}

    const handleContextMenu = (e,id) => {
        e.preventDefault()
        setPosition({x : e.pageX, y: e.pageY, id})
        setShowContextMenu(true)
    }

    const handleUnread = async(e) => {
        e.preventDefault()
 
        setShowContextMenu(false)
        let _set = chatList.find(_item => {
            return parseInt(_item.idmessagehistoryheader) === parseInt(position.id)
        })

        if (_set)
            _set.unread = 0

        await api.post('/history/unread/',{
            id : position.id
        }).then((response) => {
            //
        }).catch((error) => {
           ShowMessages(error)
        })
    }

    const ElementContextMenu = () => {
        return (
            <>
                {showContextMenu && (
                    <div className={`box-shadow context-menu ${showContextMenu ? 'show' : ''}`} style={{background:"#fff", top:`${position.y - 100}px`, left:`${position.x-230}px`,width:"200px", height:"50px", zIndex:"99999", position:"absolute"}} onMouseLeave={e => setShowContextMenu(false)}>
                        <div className='box-context' onClick={e => handleUnread(e)}>
                            <div>
                                <i className='fa fa-list-check'/>
                            </div>
                            
                            <div>
                                <span>Marcar como não lida</span>
                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    }

    const importMessage = (e,to,number) => {
        e.stopPropagation()
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente importar o histório desta conversa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
          }).then(async(result) => {
            if (result.isConfirmed) {
                await api.post('/importHistoricContact/',{number,to}) 
                         .then((response) => {  
                            ShowMessages(response.data)
                        }).catch(error => {
                            ShowMessages(error)
                        })  
            }
            
          })

      
    }
    useEffect(() => {
        const showData = async() => {
            let _numberSettings = await getNumberSettings()
            showChat('','',props.to,null,null,0,0,0,null,_numberSettings,false,null) 
        }
        if (props?.newchat)
            showData()
    },[props])

    useEffect(() => {
        const getTagsAndLeads = async() => {
            const _getAnnotation = api.get("/getAnnotationTags");
            const _getClient     = api.get("/getClient");

            Promise.all([_getAnnotation, _getClient])
                   .then(([annotationResponse, clientResponse]) => {
                        setDataTag(annotationResponse.data);
                        let _leads = clientResponse.data.map(_item => ({to              : _item.phone, 
                                                                        notifyname      : _item.name,
                                                                        body            : '',
                                                                        number          : phone_format(userNumber),
                                                                        original_number : userNumber,
                                                                        isCRMLead       : true}))
                        setLeads(_leads);
                        setLeadsAll(_leads);
                    }).catch((error) => {
                        ShowMessages(error)
                    });          
        }
        getNumberSettings()
        getTagsAndLeads()
        document.addEventListener('keydown', escExit);
        return () => {
            document.removeEventListener('keydown', escExit)
            if (filterDebounceRef.current) {
                clearTimeout(filterDebounceRef.current)
                filterDebounceRef.current = null
            }
        }
    },[])

    useEffect(() => {
        const el = containerRef.current
        if (!el) return

        const handleDragOver = (e) => {
            e.preventDefault()
        }

        const handleDrop = async (e) => {
            e.preventDefault()
            const box = e.target.closest && e.target.closest('.box-chat')
            if (box) box.click()
            const _files = e.target.files || e.dataTransfer.files
            const _length = _files?.length || 0
            const files = []

            if (_length > 0) {
                for (let i = 0; i < _length; i++) {
                    if (_files[i].size > 41943040) {
                        ShowMessages({ status: 500, message: 'O arquivo informado não pode ser maior que 40Mb' })
                    } else {
                        const s = settingsRef.current
                        files.push({
                            src: URL.createObjectURL(_files[i]),
                            altText: _files[i].name,
                            file: URL.createObjectURL(_files[i]),
                            name: _files[i].name,
                            size: _files[i].size,
                            type: _files[i].type,
                            base64: await convertToBase64(_files[i]),
                            attendance: s?.showAttendenceName ? JSON.parse(ReadDataStorage(USER_DATA)).name : ''
                        })
                        setFilename(files[0])
                        setMessageType(2)
                    }
                }
                setSelectedFiles(files)
            }

            setShowPreview(true)
        }

        el.addEventListener('dragover', handleDragOver)
        el.addEventListener('drop', handleDrop)
        return () => {
            el.removeEventListener('dragover', handleDragOver)
            el.removeEventListener('drop', handleDrop)
        }
    }, [loading])

    useEffect(() => {
        const handleScroll = () => {
            if ((_div.offsetHeight + _div.scrollTop === _div.scrollHeight)){ 
                if ((page < lastPage) || (page === 1)) {
                    setPage((prevPage) => prevPage + 1)
                }
            } else if ((_div.offsetHeight + _div.scrollTop) < _div.scrollHeight)
                setInfiniteScroll(false)
        };
      
        if (_div)
            _div.addEventListener('scroll', handleScroll);
        return () => {
            if (_div)
                _div.removeEventListener('scroll', handleScroll);
        }
    },[_div, page])

    useEffect(() => {
        if (!infiniteScroll) 
            loadingChatList(isNotRead ? 1 : isUnanswered ? 0 : filterTag > 0 ? 0 : 0,filterTag,page)
    },[page])

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const child = containerRef.current?.querySelector(".box-chat-selected");
            if (child) {
                containerRef.current.scrollTop = child.offsetTop - 300;
            }
        });
    
        if (containerRef.current) {
          observer.observe(containerRef.current, { childList: true, subtree: true, attributes: true });
        }
    
        return () => observer.disconnect();
      }, []);

    return (
        <div>
            {loading && (
                <Loading loading={loading} /> 
            )}
            {showModal && <ModalSelectedNumber showModal={showModal} handleCloseModal={handleCloseModal} props={propsShowChat} showChat={showChat}/>}
            {showContextMenu && <ElementContextMenu/>}
            <div className={`content-box-chat ${(loading ? "hidden" : "")}`}>       
                <div style={{width:"300px"}}>
                    <div style={{display:"flex", padding:"8px", justifyContent:"space-between", gap:"5px", background:"#f7f8f9"}}>
                        <div style={{width:"100%"}}>
                            <input
                                ref={searchInputRef}
                                className='form-control'
                                defaultValue=''
                                placeholder='Digite para pesquisar...'
                                onChange={onSearchInputChange}
                            />
                        </div>
                        <div style={{display:"flex", flexDirection:"column"}} title="Filtros">
                            <Dropdown title='Opções' variant="success" style={{textAlign:"right", display:"flex", marginTop:"-1px", padding:"2px"}} onClick={e => e.stopPropagation()}>
                                <Dropdown.Toggle  style={{padding:"7px 10px"}} variant="transparent" className='btn-transparent-chatbot' >
                                    <em className='fa fa-bars'></em>      
                                </Dropdown.Toggle>
                                {filterTag > 0 || isUnanswered || isNotRead ?  (
                                    <Dropdown.Menu style={{padding:"0px"}} >
                                        <Dropdown.Item href="#" key={1}>
                                            <div style={{display:"flex", gap:"5px", alignItems:"center"}} onClick={e => loadingChatList(0,0,0)}>
                                                <em className="fa fa-bell"></em>  
                                                <span>Todas as Conversas</span>
                                            </div>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                ) : (
                                    <Dropdown.Menu style={{padding:"0px"}} >
                                        {!isUnanswered && (
                                            <Dropdown.Item href="#" key={0}>
                                                <div style={{display:"flex", gap:"5px", alignItems:"center"}} onClick={e => loadingChatList(1,0,0)}>
                                                    <em className="fa fa-bell"></em>  
                                                    <span>Não Lidos</span>
                                                </div>
                                            </Dropdown.Item>
                                        )}

                                        {!isNotRead && (
                                            <Dropdown.Item href="#" key={1}>
                                                <div style={{display:"flex", gap:"5px", alignItems:"center"}} onClick={e => loadingChatList(2,0,0)}>
                                                    <em className="fa fa-comment-dots"></em>  
                                                    <span>Não Respondidos</span>
                                                </div>
                                            </Dropdown.Item>    
                                        )}

                                        {dataTag.length > 0 && (
                                            <>
                                                <Dropdown.Divider/>
                                                <Dropdown.ItemText>Etiquetas</Dropdown.ItemText>
                                                {dataTag.map((_item, key) => {
                                                    return (
                                                        <Dropdown.Item href="#" key={key}>
                                                            <div style={{display:"flex", gap:"5px", alignItems:"center",}} onClick={e => loadingChatList(3,_item.idtag,0)}>  
                                                                <div>
                                                                    <i className='fa fa-bookmark' style={{color:`${_item.color}`}}/>
                                                                </div>
                                                                <span>{_item.tag}</span>
                                                            </div>
                                                        </Dropdown.Item> 
                                                    )
                                                })}
                                            </>
    
                                        )}
                                    </Dropdown.Menu>
                                )}
                            </Dropdown>                          
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "3px", height: "88vh", overflowY: "auto", overflowX: "hidden", background: '#f7f8f9', paddingBottom: `${(chatList?.length || 0) > 0 ? '55px' : '0px'}` }} ref={containerRef}>
                        {(chatList || []).filter(_item => _item !== null).map((_data, id) => {
                            return (
                                <div key={id}
                                    onContextMenu={e => handleContextMenu(e, _data.idmessagehistoryheader)}
                                    style={{ padding: "0px" }}
                                    data-id={_data.idmessagehistoryheader}
                                    className={`chat_id_${_data.idmessagehistoryheader} box-shadow box-chat ${(_data.to === to) ? 'box-chat-selected' : ''}`}
                                    onClick={e => showChat(
                                        _data.notifyname || _data.to,
                                        _data.photo || USER,
                                        _data.to.toString(),
                                        _data.starthuman,
                                        _data.endhuman,
                                        JSON.parse(ReadDataStorage(USER_DATA)).user_data.isroot ? 0 : (_data.starthuman && _data.endhuman ? 0 : _data.idautomationchatheadhistory),
                                        0,
                                        _data.idattendant,
                                        _data.original_number.toString().replace(/[\W_,[a-z]+/g, ""),
                                        null,
                                        _data.isgroup,
                                        _data.participants)}>

                                    <div style={{ display: "flex", width: "100%" }}>
                                        <div style={{ background: (_data.starthuman === null ? '#28a745' : ''), width: "5px", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px", border: "0px", height: "100%", borderTopRightRadius: "0px", borderBottomRightRadius: "0px" }}>
                                            &nbsp;
                                        </div>
                                        <div style={{ width: "100%", padding: "0px 8px 2px 0px", justifyContent: "center", minHeight: "87px", display: "flex", flexDirection: "column" }}>
                                            <div style={{ display: "flex", marginLeft: `${JSON.parse(ReadDataStorage(USER_DATA)).user_data.isroot ? '0px' : '75px'}`, justifyContent: `${([0, 1, 2, 3, 4, 5].includes(settings.modeType)) ? 'space-between' : 'center'}` }}>
                                                <div style={{display:"flex",gap:"5px"}}>
                                                    {JSON.parse(ReadDataStorage(USER_DATA)).user_data.isroot && (
                                                        <div onClick={e => importMessage(e,_data.to,_data.number)} className='chat-upload-over' title="Importar histórico de conversa">
                                                            <i className='fa fa-upload' style={{ color: "#cacaca" }}></i>
                                                        </div>
                                                    )}
                                                    {JSON.parse(ReadDataStorage(USER_DATA)).user_data.isroot && !_data?.isCRMLead && (
                                                        <div onClick={e => deleteMessage(_data.idmessagehistoryheader)} className='trash-over' title="Excluir chat selecionado">
                                                            <i className='fa fa-trash' style={{ color: "#cacaca" }}></i>
                                                        </div>
                                                    )}
                                                </div>
                                                {_data.number && (
                                                    <div className='bg' style={{ padding: "5px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", background: `${getColor(_data?.original_number)}` }}>
                                                        <i className='fab fa-whatsapp' style={{ fontSize: "12px", color: "#000" }} />
                                                        <span style={{ fontSize: "12px", color: "#000", marginLeft: "5px" }}>{_data.number}</span>
                                                    </div>
                                                )}

                                                {([0, 1, 2, 3, 4, 5].includes(settings.modeType)) && (
                                                    <div onClick={e => pinnedMessage(e, _data.idmessagehistoryheader)} className='pinner-over' title={_data.pinned ? "Retirar mensagem do topo" : "Fixar a mensagem no topo"}>
                                                        <i className='fa fa-thumbtack' style={{ color: `${_data.pinned ? "#28a745" : "#cacaca"}` }}></i>
                                                    </div>
                                                )}
                                            </div>
                                            <div style={{ display: "flex", marginLeft: "15px", gap: "10px" }}>
                                                <div>
                                                    <div>
                                                        <img style={{ width: "50px", height: "50px", borderRadius: "50%" }} onError={(e) => { e.target.src = USER }} src={_data.photo || USER} alt="" />
                                                    </div>
                                                    <div style={{ marginTop: "-20px", marginLeft: "30px" }}>
                                                        <img alt="" style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={WHATSAPP}></img>
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "10px" }}>
                                                    <div style={{ width: "100%" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                                            <span style={{ fontWeight: "bold" }}>{_data.notifyname || phone_format(_data.to)}</span>
                                                            {!_data.number && (
                                                                <span style={{ fontWeight: "bold" }}>{phone_format(_data.to)}</span>
                                                            )}
                                                        </div>

                                                        {((![6].includes(settings.modeType)) || ([6].includes(settings.modeType) && (!_data.endhuman))) && (
                                                            <div style={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: `${_data.hasmedia || _data.type === 'location' ? "center" : "flex-start"}` }}>
                                                                {_data.isgroup && (
                                                                    <span style={{ fontWeight: "bold", opacity: "70%" }}>{_data.notifyusergroup}:&nbsp;</span>
                                                                )}

                                                                {_data.hasmedia ?
                                                                    ((_data.type === 'image') || (_data.type === 'sticker')) ? (
                                                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                                                            <i className='fa fa-camera' style={{ fontSize: "18px", color: "#cacaca", marginLeft: "10px" }} />
                                                                        </div>
                                                                    ) : (_data.type === 'video') ? (
                                                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                                                            <i className='fa fa-video' style={{ fontSize: "18px", color: "#cacaca", marginLeft: "10px" }} />
                                                                        </div>
                                                                    ) : (_data.type === 'ptt') || (_data.type === 'audio') || (_data.type === 'audio/ogg; codecs=opus') ? (
                                                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                                                            <i className={!isRecording ? 'fa fa-microphone' : 'fa fa-microphone-slash'} style={{ fontSize: "18px", color: "#cacaca", marginLeft: "10px" }} />
                                                                        </div>
                                                                    ) : (_data.type === 'vcard') ? (
                                                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                                                            <i className='fa fa-address-card' style={{ fontSize: "18px", color: "#cacaca", marginLeft: "10px" }} />
                                                                        </div>
                                                                    ) : (
                                                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                                                            <i className='fa fa-file' style={{ fontSize: "18px", color: "#cacaca", marginLeft: "10px" }} />
                                                                        </div>
                                                                    )
                                                                    :
                                                                    <>
                                                                        {(_data.type === 'location') ? (
                                                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                                                <i className='fa fa-map-location' style={{ fontSize: "18px", color: "#cacaca", marginLeft: "10px" }} />
                                                                            </div>
                                                                        ) : (
                                                                            <span style={{ opacity: "70%" }} dangerouslySetInnerHTML={{ __html: messageCustom((_data?.body?.toString().length > 25 ? _data?.body?.toString()?.substr(0, 25) + '...' : _data?.body?.toString()) || '', _data.original_number?.toString().replace(/[\W_,[a-z]+/g, "")) }}></span>
                                                                        )}
                                                                    </>
                                                                }
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <div style={{ textAlign: "center", lineHeight: "10px", width: "60px" }}>
                                                            <span style={{ fontSize: "10px" }}>{_data.update_at && getDataNameAndHour(new Date(_data.update_at))}</span>
                                                        </div>

                                                        <div>
                                                            {getUnread(_data.unread,ReadDataStorage(IDUSER)) > 0 && (
                                                                <div style={{ textAlign: "center" }}>
                                                                    <span className='badge badge-success'>{getUnread(_data.unread,ReadDataStorage(IDUSER))}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", marginLeft: "5px", gap: "10px", marginTop: "5px" }}>
                                                <div>
                                                    {(toMap(_data.tags || '[{}]').map((_item, id) => {
                                                        return (
                                                            <div key={id} style={{ padding: "2px 5px", borderRadius: "5px", background: `${_item.color}` }}>
                                                                <i className='fa fa-tag' style={{ fontSize: "10px" }} />
                                                                <span style={{ fontSize: "10px" }}> {_item.text}</span>
                                                            </div>
                                                        )
                                                    }))}
                                                </div>
                                                {(_data.starthuman !== null) && (_data.endhuman === null) && (
                                                    <>
                                                        <div>
                                                            <div style={{ height: "100%", display: "flex", alignItems: "end" }}>
                                                                <CountUp initialDate={_data.starthuman} />
                                                            </div>
                                                        </div>
                                                        <div style={{ display: "flex" }}>
                                                            <span style={{ fontSize: "10px" }} className='text-success'>{_data.name.toString().toUpperCase()}</span>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}

                        {(((chatList?.length || 0) === 0) && (textSearch?.length >= 10)) && (
                            <div style={{ display: "flex", gap: "10px" }} className="box-shadow box-lead" onClick={e => showChat(
                                textSearch,//notifyName
                                '',//photo
                                textSearch.toString().replace(/[\W_,[a-z]+/g, ""),//to
                                null,//_startHuman
                                null,//_endHuman
                                0,//idautomationchatheadhistory
                                0,//idpeople
                                0,//idAttendant
                                null,//number
                                null,
                                false,
                                null)}>

                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                    <i className='fa fa-circle-plus' style={{ fontSize: "34px", color: "#20c997" }} />
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                    <span style={{ fontWeight: "bold" }}>Novo Contato</span>
                                    <span>{phone_format(textSearch)}</span>
                                </div>
                            </div>
                        )}

                        {((chatList?.length || 0) === 0) && (textSearch?.length < 10) && (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flex: "1", border: "1px dashed #cacaca", borderRadius: "5px" }}>
                                <div className='bg alert alert-warning' style={{ padding: "15px", borderRadius: "5px", display: "flex", alignItems: "center" }}>
                                    <i style={{ fontSize: "20px", color: "#000" }} className='fa fa-warning' />
                                    <span style={{ fontSize: "16px", color: "#000", marginLeft: "5px" }}>Nenhuma conversa foi iniciada!</span>
                                </div>
                            </div>
                        )}

                        {loadingInfinite && (
                            <div style={{ display: "flex", gap: "5px", justifyContent: "center", padding: "15px 0px", alignItems: "center" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <i className='fa fa-spin fa-spinner' />
                                </div>
                                <span>Carregando conversas</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}